var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, observable } from "mobx";
import { AddJoinCommonInformedConsentBaseViewModel } from "./AddJoinCommonInformedConsentBaseViewModel";
export class AddJoinCommonInformedConsentPreviewViewModel extends AddJoinCommonInformedConsentBaseViewModel {
    constructor(opts) {
        super(opts);
        this.previewConsentDialogOpen = false;
        this.patientConsentUIManager = opts.container.patientConsentUIManager;
        this.studyPDFPreviewUIManager = opts.container.studyPDFPreviewUIManager;
    }
    get isProjectSettingsCompleted() {
        return this.addProjectUIManager.isProjectSettingsCompleted;
    }
    get isPatientExperienceCompleted() {
        return this.addProjectUIManager.isPatientExperienceCompleted;
    }
    async saveInformedConsent() {
        await this.addProjectUIManager.saveInformedConsent();
    }
}
__decorate([
    observable
], AddJoinCommonInformedConsentPreviewViewModel.prototype, "previewConsentDialogOpen", void 0);
__decorate([
    computed
], AddJoinCommonInformedConsentPreviewViewModel.prototype, "isProjectSettingsCompleted", null);
__decorate([
    computed
], AddJoinCommonInformedConsentPreviewViewModel.prototype, "isPatientExperienceCompleted", null);
